import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Limpiar token y datos de usuario
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    //  Redirigir al login
    navigate("/login", { replace: true });
  }, [navigate]);

  return null; // no renderiza nada, solo ejecuta el efecto
};

export default Logout;
